import { SET_GROUPS_ROLES, SET_CURRENT_GROUPS_ROLES_WITH_LEVEL, RESET_GROUPS_ROLES, } from './constants';
export const setGroupsRoles = (groupsIds) => (dispatch) => {
    dispatch({ type: SET_GROUPS_ROLES, payload: groupsIds });
};
export const setCurrentGroupsRolesWithLevel = (groups) => (dispatch) => {
    dispatch({ type: SET_CURRENT_GROUPS_ROLES_WITH_LEVEL, payload: groups });
};
export const resetGroupsRoles = () => (dispatch) => {
    dispatch({ type: RESET_GROUPS_ROLES });
};
